import 'slick-carousel';
//import 'jquery-validation';
//import 'jquery-validation-unobtrusive';


const pooCheck = {};

(function (pooCheckApp) {
    let answers = [];
    let dogName = "";

    function initializeSliders() {
        $('.js-quiz-tile-slider').slick({
            fade: false,
            dots: false,
            arrows: true,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            mobileFirst: true,
            prevArrow:
                '<button class="button slick-prev slick-arrow"><span><svg class="icon" role="presentation" id="slick-prev-icon"><use xlink:href="#icon-chevron-left"></use></svg> Back</span></button>',
            nextArrow:
                '<button class="button slick-next slick-arrow"><span>Next <svg class="icon" role="presentation" id="slick-next-icon"><use xlink:href="#icon-chevron-right"></use></svg></span></button>',
            appendArrows: $(".quiz-tile-slider-buttons"),
            responsive: [
                {
                    breakpoint: 767,
                    settings: "unslick"
                }
            ]
        });

        $('.js-quiz-question-slider').slick({
            fade: false,
            dots: true,
            arrows: true,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow:
                '<button class="slick-prev slick-arrow"><span class="screen-reader-text">Previous slide</span> <svg class="icon" role="presentation" id="slick-prev-icon"><use xlink:href="#icon-arrow-left"></use></svg></button>',
            nextArrow:
                '<button class="slick-next slick-arrow"><span class="screen-reader-text">Next slide</span> <svg class="icon" role="presentation" id="slick-next-icon"><use xlink:href="#icon-arrow-right"></use></svg></button>'
        });
    }

    function replaceDogName() {
        $('main :not(script)').contents().filter(function () {
            return this.nodeType === 3 && this.nodeValue.indexOf('{DogName}') != -1;
        }).replaceWith(function () {
            return this.nodeValue.replace("{DogName}", dogName);
        });
    }

    function optionSelectCallback(quizQuestionPopup) {
        const caption = quizQuestionPopup.find('.slick-active .quiz-question-popup__caption p').text();
        const sfMappingCategory = quizQuestionPopup.data("salesforcecategory");
        const sfMapping = quizQuestionPopup.find('.slick-active .quiz-question-popup__caption').data("salesforce");
        const url = quizQuestionPopup.find('.slick-active .quiz-question-popup__image img').attr("src");
        const datatag = quizQuestionPopup.find('.slick-active .quiz-question-popup__slide');
        const shortName = quizQuestionPopup.data("shortname");
        const stepIndex = quizQuestionPopup.data("index");
        const answerObject = {
            name: datatag.data("name"),
            salesForceMappingCategory: sfMappingCategory,
            salesForceMapping: sfMapping,
            caption: caption,
            image: url,
            isHealthy: datatag.data("isHealthy"),
            resultText: datatag.data("result")
        };

        if (answers.length === 0 || answers.length < stepIndex + 1) {
            answers.push(answerObject);
        } else {
            answers[stepIndex] = answerObject;
        }

        quizQuestionPopup.parent().find('.quiz-question__image img').attr("src", url);
        quizQuestionPopup.parent().find('.quiz-question__image').show();

        quizQuestionPopup.parent().find('.quiz-question__title .quiz-question__link').text(shortName);
        const stepNumber = stepIndex + 1;
        $('.quiz-question').each((i, obj) => {
            if (i + 1 == stepNumber && !$(obj).hasClass("is-complete")) {
                $(obj).removeClass("is-active");
                $(obj).addClass("is-complete");
                $(obj).find(".quiz-question__completed").show();
                $(obj).find(".quiz-question__status#status__complete").show();
                $(obj).find(".quiz-question__status#status__incomplete").hide();
                $(obj).find("svg").hide();

                const activeNode = $('.quiz-progress__item.is-active');
                activeNode.removeClass('is-active');
                activeNode.addClass('is-complete');
                if (activeNode.next().length == 1) {
                    activeNode.next().addClass('is-active');
                } else {
                    $('.quiz-results-button button').attr("disabled", false);
                }
            } else if (i == stepNumber) {
                $(obj).addClass("is-active");
            }
        });
    }

    pooCheckApp.submitPooCheckEmailForm = function () {
        const emailResultData = {
            EmailAddress: $('#sf-email').val(),
            FirstName: $('#sf-first-name').val(),
            LastName: $('#sf-last-name').val(),
            PetName: $('#dogName').val(),
            DateOfBirth: $('#dob').val()
        };
        //Pet_PooCheck_Colour__c | Pet_PooCheck_Content__c | Pet_PooCheck_Consistency__c | Pet_PooCheck_Food__c
        emailResultData.Consistency = answers.find(x => x.salesForceMappingCategory === "Pet_PooCheck_Consistency__c")?.salesForceMapping;
        emailResultData.Colour = answers.find(x => x.salesForceMappingCategory === "Pet_PooCheck_Colour__c")?.salesForceMapping;
        emailResultData.Contents = answers.find(x => x.salesForceMappingCategory === "Pet_PooCheck_Content__c")?.salesForceMapping;
        emailResultData.Food = answers.find(x => x.salesForceMappingCategory === "Pet_PooCheck_Food__c")?.salesForceMapping;

        $.ajax({
            url: "/umbraco/surface/PooCheckSurface/Submit",
            type: "GET",
            data: emailResultData,
            dataType: "html",
            success: function (data) {
                $(".js-poocheck-form-container").html(data);
            },
            error: function (xhr, status, error) {
                console.log(status);
                console.log(xhr.status + " - " + error);
            }
        });
    }

    $(document).ready(function () {
        const poocheckButton = $('#poocheck-next-btn');
        const quizIntro = $('.quiz-intro');

        initializeSliders();

        $('.poocheck-form :input').on('keyup change',
            function () {
                setNextButtonState();
            });

        function setNextButtonState() {
            if ($('.poocheck-form #dogName').val() && $('.poocheck-form #dob').val()) {
                poocheckButton.attr("disabled", false);
            } else {
                poocheckButton.attr("disabled", true);
            }
        }

        poocheckButton.click(function (e) {
            e.preventDefault();

            dogName = $('#dogName').val();
            $('.quiz').data("dogname", dogName);
            replaceDogName();
            const dateString = $('.poocheck-form #dob').val();
            const nowDate = new Date();
            const birthDate = new Date(dateString);
            let years = nowDate.getFullYear() - birthDate.getFullYear();
            let months = nowDate.getMonth() - birthDate.getMonth();
            if (months < 0) {
                years -= 1;
                months = 11 - months;
            }
            $('.quiz-pet-name h2').text(dogName);
            $('.quiz-pet-name p.label')
                .text(`${years} year${years > 1 ? 's' : ''} ${months} month${months > 1 ? 's' : ''} old`);

            quizIntro.hide();
            $('.quiz-pet-name').show();
            $('.quiz-question-grid').show();
            $('.quiz-tile-slider-buttons').show();
            $('.quiz-progress').show();

            $(".js-quiz-results-button").css("display", "block");
        });

        $('#results-button').click(function () {
            if (answers.every((ans) => ans.isHealthy)) {
                $('#results').show();
            } else {
                $('#results-bad').show();
                $('.quiz-results-form').show();
                $('#free-sample').show();
            }
            $('.js-content-blocks').show();
            $('body').removeClass('page--quiz');
            $('.quiz-results-table__grid-item').each((i, obj) => {
                const gridItem = $(obj);
                const name = gridItem.data("name");
                const answer = answers.find(ans => ans.name === name);
                gridItem.find('.quiz-results-table__grid-item-image img').attr("src", answer.image);
                gridItem.find('p.label').append(answer.caption)
                gridItem.find('.quiz-results-table__grid-item-content').append(answer.resultText)
            });

            $('#quiz').hide();
        });

        //change to on click as on submit causing errors with tfa/wforms.js
        $(document).on("click", "#sf-button", function (e) {
            e.preventDefault();
            //TODO: jquery validation not working
            //if ($("#poocheck-email-form").valid()) {
            //    submitPooCheckEmailForm();
            //}
            pooCheckApp.submitPooCheckEmailForm();
        });

        $(document).on("keyup",
            "#sf-first-name, #sf-last-name, #sf-email",
            function (event) {
                if (event.keyCode === 13) {
                    $("#sf-button").click();
                }
            });

        if (window.matchMedia("(max-width: 1023px)").matches) {
            $(".quiz-question-popup").appendTo(".mobile-popup-destination");
        }

        $(".quiz-question__link").click(function (e) {
            e.preventDefault();
            const popup = $(this).data("popup");
            $(".quiz-question-popup").fadeOut();
            $("#" + popup).fadeIn();
            $(`#${popup} .js-quiz-question-slider`).slick('refresh');
        });

        $(".quiz-question-popup__select-button").click(function (e) {
            $(this).parents(".quiz-question-popup").fadeOut();
            optionSelectCallback($(this).parents(".quiz-question-popup"));
        });
    });

})(pooCheck);
